// extracted by mini-css-extract-plugin
module.exports = {"container":"BtnContainer_container_2cryg","center":"BtnContainer_center_VdRpa","left":"BtnContainer_left_1rGIt","right":"BtnContainer_right_350Hv"};